<div style="display: flex; flex-direction: row; align-items: center;">
  <nb-icon icon="checkmark-outline" pack="eva"></nb-icon>
  {{ posVotes }}
  <nb-icon style="margin-left: 15px" icon="close-outline" pack="eva"></nb-icon>
  {{ negVotes }}
</div>
